/*
 * Affiliate-branded Deactivated Page: Deal Sauce (pacemorby/astroflip) and Property Edge Pro (pep)
 */

import React, { useState } from 'react'
import { toLower, get } from '@/utils/lodash'

import { Button, Container, Grid, Box } from '@mui/material'

import particles2 from '@/assets/images/hero-bg/particles-2.svg'
import { ApolloConsumer } from '@/components/ApolloConsumer'
import { signOut } from '@/housefolios-components/SignOut'
import withSession from '@/housefolios-components/Session/withSession'
import ContactSupport from '@/housefolios-components/Dialogs/ContactSupport'
import useAffiliate from '@/hooks/useAffiliate'
import UnifiedSubscribeDialog from '@/housefolios-components/Session/UnifiedSubscribeDialog'

function AffiliateDeactivatedPageComponent(props) {
  const [supportOpen, setSupportOpen] = useState(false)
  const [showSubscribe, setShowSubscribe] = useState(false)

  const member = toLower(props?.session?.me?.activeOrg?.member || '')
  const isAffiliateBrand = ['pacemorby', 'astroflip', 'pep'].includes(
    member,
  )
  const brandName =
    member === 'pep'
      ? 'Property Edge Pro'
      : member === 'pacemorby' || member === 'astroflip'
        ? 'Deal Sauce'
        : 'Account'
  const isCreator =
    props?.session?.me?._id ===
    props?.session?.me?.activeOrg?.createdBy?._id

  // Get org creator's name for display
  const creator = props?.session?.me?.activeOrg?.createdBy
  const creatorName =
    creator?.profile?.firstname && creator?.profile?.lastname
      ? `${creator.profile.firstname} ${creator.profile.lastname}`
      : creator?.email || 'your Org Creator'

  const [{ affiliate, affiliateLoading, urlHelmetData }] =
    useAffiliate({
      memberValue: props?.session?.me?.activeOrg?.member,
    })
  const logoSrc =
    get(affiliate, 'createAccount.headerImage.0.url') ||
    urlHelmetData?.icon ||
    null

  return (
    <>
      <div style={{flexGrow:1,display:"flex",zIndex:6,width:"100%",alignItems:"center"}}>
        <Box style={{ backgroundImage: 'url(' + particles2 + ')' }} sx={{
          position: "absolute",
          left: 0,
          top: 0,
          height: "100%",
          width: "100%",
          zIndex: 3,
          opacity: "0.7 !important",
          filter: "grayscale(0%)",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          borderTopLeftRadius: "inherit",
          borderTopRightRadius: "inherit",
        }} />
        <Box sx={{ position: "relative", zIndex: "7", width: "100%" }}>
          <Box sx={{
            "@media (min-width: 1440px)": { py: "3rem" },
            py: "1rem",
          }}>
            <Container sx={[{ py: '3rem' }, {
              color: "#070919",
              "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.87) !important" },
            }]}>
              <Grid container spacing={6}>
                <Grid
                  size={{
                    xl: 6,
                  }}
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  <div>
                    <Box
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      <Box
                       
                        sx={{
                          display: "inline-block",
                          py: "0.25rem",
                          px: "1.5rem",
                          fontSize: "70%",
                          fontWeight: 700,
                          lineHeight: "21px",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                          verticalAlign: "baseline",
                          borderRadius: "0.65rem",
                          textTransform: "uppercase",
                          height: "auto",
                          pr: "0.85em",
                          pl: "0.85em",
                          color: "#fff",
                          backgroundColor: "#1bc943",
                        }}
                      >
                        {brandName} Inactive
                      </Box>
                    </Box>
                    <Box sx={[{ mt: '1rem' }, {
                      color: "#070919",
                      "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.87) !important" },
                    }]}>
                      <Box component="h1" sx={[{ mb: '1rem', fontWeight: 700 }, { fontSize: "3rem", fontWeight: "300", lineHeight: "1.2" }]}>
                        Your {brandName} access is currently inactive.
                      </Box>
                      <Box component="p" sx={[{ color: 'rgba(7, 9, 25, 0.5)' }, { fontSize: "1.15rem !important" }]}>
                        This can happen after a cancellation or a
                        failed/missed payment.
                      </Box>
                      <Box
                        component="p"
                        sx={{ color: 'rgba(7, 9, 25, 0.5)' }}
                      >
                        If this is an error, contact {creatorName}. If
                        you are the Org Creator, press the Subscribe
                        button to sign up for a plan.
                      </Box>
                      <Box sx={[{ my: '1.5rem', borderRadius: '50%', width: '25%', }, { borderWidth: "2px !important", borderStyle: "solid !important", opacity: "0.2 !important" }, { background: "#eeeff8", height: "1px", overflow: "hidden" }]} style={{ borderColor: '#f4f5fd' }} />
                      <div>
                        {isCreator &&
                          isAffiliateBrand &&
                          member !== 'pep' && (
                            <Button
                              href={null}
                              onClick={() => setShowSubscribe(true)}
                              size="large"
                             
                              sx={{
                                boxShadow: "0 0.25rem 0.55rem rgba(65, 145, 255, 0.35)",
                                color: "#fff",
                                backgroundColor: "#4191ff",
                                backgroundImage: "none",
                                borderColor: "#4191ff",
                                "&:not(:disabled):hover": { backgroundColor: "#4191ff", color: "#fff" },
                                "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#0e73ff" },
                                "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(65, 145, 255, 0.4), 0 0.0625rem 0.385rem rgba(65, 145, 255, 0.54)" },
                                "&:not(:disabled).active .btn-wrapper--icon svg path, &:hover .btn-wrapper--icon svg path": { fill: "#fff" },
                                "@media (min-width: 576px)": { display: "inline-block" },
                                display: "block",
                                mr: "1rem",
                              }}
                            >
                              <Box component="span" sx={{
                                display: "inline-block",
                                "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                                "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
                              }}>
                                Subscribe
                              </Box>
                            </Button>
                          )}
                        <Button
                          href={null}
                          onClick={() => setSupportOpen(true)}
                          size="large"
                         
                          sx={{
                            boxShadow: "0 0.25rem 0.55rem rgba(65, 145, 255, 0.35)",
                            color: "#fff",
                            backgroundColor: "#4191ff",
                            backgroundImage: "none",
                            borderColor: "#4191ff",
                            "&:not(:disabled):hover": { backgroundColor: "#4191ff", color: "#fff" },
                            "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#0e73ff" },
                            "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(65, 145, 255, 0.4), 0 0.0625rem 0.385rem rgba(65, 145, 255, 0.54)" },
                            "&:not(:disabled).active .btn-wrapper--icon svg path, &:hover .btn-wrapper--icon svg path": { fill: "#fff" },
                            "@media (min-width: 576px)": { display: "inline-block" },
                            display: "block",
                          }}
                        >
                          <Box component="span" sx={{
                            display: "inline-block",
                            "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                            "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
                          }}>
                            Contact support
                          </Box>
                        </Button>
                        <ApolloConsumer>
                          {(client) => (
                            <Button
                              href={null}
                              onClick={() =>
                                signOut(
                                  client,
                                  props?.session?.me?.activeOrg
                                    ?.member,
                                )
                              }
                              size="large"
                              variant="text"
                             
                              sx={{
                                backgroundColor: "transparent",
                                color: "#4191ff",
                                border: "#4191ff solid 2px",
                                "&:not(:disabled):hover": { boxShadow: "0 0.22rem 0.525rem rgba(65, 145, 255, 0.4), 0 0.0625rem 0.385rem rgba(65, 145, 255, 0.54)", backgroundColor: "#4191ff", color: "#fff" },
                                "&:not(:disabled).active, &:hover": { backgroundColor: "#4191ff", color: "#fff" },
                                "@media (min-width: 576px)": { display: "inline-block", mt: 0, ml: "1rem" },
                                display: "block",
                                ml: 0,
                                mt: "1rem",
                              }}
                            >
                              <span>Sign Out</span>
                            </Button>
                          )}
                        </ApolloConsumer>
                      </div>
                    </Box>
                  </div>
                </Grid>
                <Grid
                 
                  size={{
                    xl: 6,
                  }}
                  sx={[{
                    "@media (min-width: 1440px)": { display: "flex" },
                  }, {
                    px: 0,
                    display: 'none',
                    alignItems: 'center',
                  }]}
                >
                  {logoSrc ? (
                    <Box
                      component="img"
                      src={logoSrc}

                      alt={`${brandName} logo`}
                      style={{ maxHeight: 240, objectFit: 'contain' }}
                      sx={{
                        width: '75%',
                        mx: 'auto',
                        display: 'block',
                        maxWidth: '100%',
                        height: 'auto',
                      }}
                    />
                  ) : (
                    <div style={{ height: 200 }} />
                  )}
                </Grid>
              </Grid>
            </Container>
          </Box>
        </Box>
      </div>

      <ContactSupport
        open={supportOpen}
        handleClose={() => setSupportOpen(false)}
        affiliate={props?.session?.me?.activeOrg?.member}
        dealsauceStripeCustomerID={
          props?.session?.me?.activeOrg?.dealsauceStripeCustomerID
        }
        goHighLevelId={props?.session?.me?.activeOrg?.goHighLevelId}
        session={props?.session}
        hidePlanActions={true}
      />

      {/* Unified subscribe dialog (same as Switch Plan in Contact Support) */}
      {member !== 'pep' && (
        <UnifiedSubscribeDialog
          open={showSubscribe}
          onClose={() => setShowSubscribe(false)}
          session={props.session}
        />
      )}
    </>
  )
}

export default withSession(AffiliateDeactivatedPageComponent)
